export const multiSelectSingleLineTagStyle = (isDarkMode: boolean) => ({
  control: (styles: any, state: any) => ({
    ...styles,
    display: 'flex',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    flexWrap: 'nowrap', // ✅ Prevents wrapping
    backgroundColor: isDarkMode ? '#262A2F' : '#fff',
    borderColor: state.isFocused
      ? isDarkMode
        ? '#fff'
        : '#b0c4de'
      : isDarkMode
      ? '#262A2F'
      : '#ddd',
    boxShadow: state.isFocused
      ? isDarkMode
        ? '0 0 5px rgba(255, 255, 255, 0.5)'
        : '0 0 5px rgba(0, 0, 255, 0.2)'
      : styles.boxShadow,
    transition: 'border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    '&:hover': {
      borderColor: isDarkMode ? '#fff' : '#b0c4de',
      boxShadow: isDarkMode
        ? '0 0 5px rgba(255, 255, 255, 0.5)'
        : '0 0 5px rgba(0, 0, 255, 0.2)',
    },
    outline: 'none',
  }),

  option: (styles: any, state: any) => ({
    ...styles,
    overflow: 'hidden',
    flexWrap: 'wrap',
    backgroundColor: state.isFocused ? '#4bb189' : 'transparent',
    color: isDarkMode ? '#ffffff' : '#000000',
    padding: 10,
    ':hover': {
      color: '#fff',
    },
  }),

  valueContainer: (styles: any) => ({
    ...styles,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap', // ✅ Prevents wrapping
    overflowX: 'auto', // ✅ Enables horizontal scrolling
    whiteSpace: 'nowrap', // ✅ Ensures inline display
    maxWidth: '100%',
    scrollbarWidth: 'thin', // ✅ Thin scrollbar
    '::-webkit-scrollbar': {
      height: '2px', // ✅ Thin scrollbar height
    },
    '::-webkit-scrollbar-thumb': {
      background: '#ccc',
      borderRadius: '2px',
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: '#999',
    },
  }),

  multiValue: (styles: any, { data }: any) => ({
    ...styles,
    backgroundColor: `color-mix(in srgb, ${
      data.color ? data.color : '#4bb189'
    } 15%, transparent)`,
    borderRadius: '999px',
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 6px',
    marginRight: '4px',
    whiteSpace: 'nowrap', // ✅ Keeps items inline
    flexShrink: 0, // ✅ Prevents squeezing when overflowed
  }),

  multiValueLabel: (styles: any, { data }: any) => ({
    ...styles,
    color: data.color ? data.color : '#4bb189',
    padding: 0,
    fontSize: '0.75rem',
    fontWeight: 500,
    marginRight: '4px',
  }),

  multiValueRemove: (styles: any, { data }: any) => ({
    ...styles,
    color: data.color ? data.color : '#4bb189',
    paddingLeft: '4px',
    paddingRight: '4px',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: 'transparent',
      color: '#000',
    },
  }),

  clearIndicator: (styles: any) => ({
    ...styles,
    color: '#888',
    cursor: 'pointer',
    ':hover': {
      color: 'red',
    },
  }),

  input: (styles: any) => ({
    ...styles,
    color: isDarkMode ? '#ffffff' : '#000000',
  }),

  indicatorsContainer: (styles: any) => ({
    ...styles,
    whiteSpace: 'nowrap', // ✅ Keeps clear and dropdown buttons aligned
  }),
});
